export default __webpack_public_path__ + "static/arindamLehri8-d06a8640828af01cfecc2b83b95def4e.jpg";